
import {get_payment_type,get_renewal_method,get_renewal_type,get_renewal_status,get_platform_type} from "@/api/mpApi"


async function getPaymentTypeList() {
    let res = await get_payment_type()
    if(res.code===200){
        return res.data
    }
}
async function getRenewalMethodList() {
    let res = await get_renewal_method()
    if(res.code===200){
        return res.data
    }
}
async function getRenewalTypeList() {
    let res = await get_renewal_type()
    if(res.code===200){
        return res.data
    }
}
async function getRenewalStatusList() {
    let res = await get_renewal_status()
    if(res.code===200){
        return res.data
    }
}
async function getPlatformTypeList() {
    let res = await get_platform_type()
    if(res.code===200){
        return res.data
    }
}     
export default {
    namespaced: true,
    state: {
        paymentTypeList:[],//缴费类型
        renewalMethodList:[],//续费方式
        renewalTypeList:[],//续费类型
        renewalStatusList:[],//续费状态
        platformTypeList:[]//平台类型
    },
    getters: {},
    mutations: {
        get_payment_type_list(state,data){
            state.paymentTypeList=data
        },
        get_renewal_method_list(state,data){
            state.renewalMethodList=data
        },
        get_renewal_type_list(state,data){
            state.renewalTypeList=data
        },
        get_renewal_status_list(state,data){
            state.renewalStatusList=data
        },
        get_platform_type_list(state,data){
            state.platformTypeList=data
        },
    },
    actions: {
        async get_enums_all({commit}) {
            let paymentTypeData=await getPaymentTypeList()
            commit("get_payment_type_list", paymentTypeData)
            let renewalMethodData=await getRenewalMethodList()
            commit("get_renewal_method_list", renewalMethodData)
            let renewalTypeData=await getRenewalTypeList()
            commit("get_renewal_type_list", renewalTypeData)
            let renewalStatusData=await getRenewalStatusList()
            commit("get_renewal_status_list", renewalStatusData)
            let platformTypeData=await getPlatformTypeList()
            commit("get_platform_type_list", platformTypeData)
        }

    }
}